var _circle, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3, _circle4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNafl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#FFEFCC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.168,
    cy: 110.417,
    rx: 12.5,
    ry: 14.5833,
    fill: "url(#paint0_radial_997_9036)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.668 41.6666V83.3333",
    stroke: "url(#paint1_linear_997_9036)",
    strokeWidth: 1.8,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.164 41.6667V83.3334",
    stroke: "url(#paint2_linear_997_9036)",
    strokeWidth: 1.8,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.716 96.2799L111.269 95.4985L112.832 94.6054L113.279 95.3868L111.716 96.2799ZM113.279 154.613C113.032 155.045 112.482 155.195 112.051 154.948C111.619 154.702 111.469 154.152 111.716 153.72L113.279 154.613ZM113.279 95.3868L124.275 114.631L122.712 115.524L111.716 96.2799L113.279 95.3868ZM124.275 135.369L113.279 154.613L111.716 153.72L122.712 134.476L124.275 135.369ZM124.275 114.631C127.947 121.056 127.947 128.944 124.275 135.369L122.712 134.476C126.068 128.604 126.068 121.396 122.712 115.524L124.275 114.631Z",
    fill: "url(#paint3_linear_997_9036)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8359 77.0833C45.8359 65.4167 56.947 56.9444 62.5026 54.1667C65.8359 52.1337 76.3915 50.5418 81.2526 50H162.503C166.669 50 170.836 50 170.836 56.25C170.836 62.5 141.669 83.3333 125.003 89.5833C108.336 95.8333 93.7526 122.917 72.9193 131.25C56.9046 137.656 48.584 129.186 46.1093 123.585C45.9154 123.147 45.8359 122.679 45.8359 122.199V77.0833Z",
    fill: "#FFD443"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.421 90.2406C123.946 90.0013 124.473 89.7818 125.003 89.5833C141.669 83.3333 170.836 62.5 170.836 56.25C170.836 50 166.669 50 162.503 50H125.232C120.243 59.2593 116.847 73.5524 123.421 90.2406Z",
    fill: "#FFA51F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.176 50.001C158.51 61.553 145.232 80.7592 118.759 89.5833C103.516 94.6643 94.8136 105.253 87.3341 114.353C76.4239 127.627 68.1166 137.734 45.9102 122.962C45.9543 123.175 46.0194 123.383 46.1088 123.585C48.5835 129.186 56.9041 137.656 72.9188 131.25C83.8153 126.891 93.002 117.403 101.671 108.45C109.577 100.285 117.053 92.5644 125.002 89.5833C141.669 83.3333 170.835 62.5 170.835 56.25C170.835 50.3371 167.106 50.0182 163.176 50.001Z",
    fill: "#FFD443"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.4193,
    cy: 110.417,
    r: 2.08333,
    fill: "#FFA51F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.7513,
    cy: 114.583,
    r: 2.08333,
    fill: "#FFA51F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.4193,
    cy: 118.75,
    r: 2.08333,
    fill: "#FFA51F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_997_9036",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.085 108.333) rotate(60.2551) scale(16.7964 18.4325)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0910347,
    stopColor: "#85A6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A86CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_997_9036",
    x1: 115.668,
    y1: 41.6666,
    x2: 117.668,
    y2: 41.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AAADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718273,
    stopColor: "#7398D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4979C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_997_9036",
    x1: 103.164,
    y1: 41.6667,
    x2: 105.164,
    y2: 41.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E94444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#BA1212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB3E3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_997_9036",
    x1: 108.331,
    y1: 95.8334,
    x2: 116.664,
    y2: 93.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E94444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71809,
    stopColor: "#BA1212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB3E3E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNafl);
export default __webpack_public_path__ + "static/media/nafl.7ea330de3044217b29eb2e84b2e6d513.svg";
export { ForwardRef as ReactComponent };